import moment from 'moment';

export default (date) => {
  return moment().year() !== moment(date).year
    ? moment(date).format('D MMM, h:mma')
    : moment(date).format('L h:mma');
};
